export class ADMIN {
  static TABLE_HEAD = [
    { id: 'row', label: '' },
    { id: 'username', label: 'username' },
    { id: 'email', label: 'email' },
    { id: 'userState', label: 'userState' },
    { id: 'telephone', label: 'telephone' },
    { id: 'moreMenu', label: '' }
  ];

  static ADMIN_STATE = ['normal', 'blocked'];

  static SEARCH_FIELDS = ['username', 'email', 'telephone'];
}
